import config from "../config.json"
import globals from "../globals"

export default {

  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_URL || config.apiUrl
    },
    app() {
      return globals.app
    },
    api() {
      return globals.api
    },
    router() {
      return globals.router
    },
    lang() {
      return this.app.language
    },
    countryCode() {
      return this.app.bootstrap.country
    },
    config() {
      return config
    }
  },

  data() {
    let otherLanguage = null
    let currentLanguage = globals.app.language.langcode
    let sortedLanguages = globals.app.languages.list
    sortedLanguages.sort(function(a, b) {
      if(a.langcode === currentLanguage) {
        return -1
      } else {
        return 1
      }
      return 0
    })

    sortedLanguages.every((lang) => {
      if(lang.langcode !== currentLanguage) {
        otherLanguage = lang
        return false
      }
      else return true
    })
    return {
      isReady: false,
      showRemoveConfirmation: false,
      languages: sortedLanguages,
      currentLanguage: currentLanguage,
      otherLanguage: otherLanguage,
      isAdminPage: window.location.pathname.match(/\/.*\/admin($|\/.*)/) !== null
    }
  },

  methods: {
    link(path: string): string {
      return globals.app.link(path)
    },

    languageToggle(language: string): string {
      let components = globals.router.currentRoute.fullPath.split('/')
      components[1] = language
      return components.join('/')
    },

    languageSelect(payload) {
      window.location.href = this.languageToggle(payload.target.value)
    },

    ready() {
      this.isReady = true
      this.app.hideLoading()
    },

    log(value: any) {
      console.log(value)
    },

    t(source: string, params?: any): string {
      return globals.app.t(source, params)
    }
  }

}